import { manageUpdateAccessObj } from "../features/manageUpdateAccess/manageUpdateAccessTypes";
import { ChannelkartNetworkGet, ChannelkartNetworkPut } from "./networkService";
export interface updateConfigRequestBody{
    domainName: string,
    domainType: string,
    domainValues: any[],
    lob: string
}
export async function fetchConfig(){
    const url = '/metadata/clientconfig';
    try{
        const response = await ChannelkartNetworkGet(url);
        const config = response.data.features.find((Obj: { domainType: string }) => {
            return Obj.domainType === 'customer_configuration';
        })
        return config.domainValues;
    }catch(err){
        console.log(err);
        return [];
    }
}
export async function updateClientConfig(requestBody: updateConfigRequestBody,configName: string,verifiedUser?: manageUpdateAccessObj){
    try {
        const url = verifiedUser? `/metadata/clientconfig?name=${configName}&verifiedBy=${verifiedUser.phoneNumber}` : `/metadata/clientconfig?name=${configName}`;
        const response = await ChannelkartNetworkPut(url,requestBody);
        return response;
    } catch (error) {
        console.log(error);
        throw error;
    }
}